var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext, useEffect, useRef } from 'react';
import { Animated, View } from 'react-native';
import { useBreakpoint } from '../../../hooks';
import { StateConfigContext } from '../../../providers';
import { getTestId } from '../../../utils';
import { getSkeletonLoaderProps, getSkeletonLoaderStyles } from '../SkeletonLoaderStyles';
import { getInterpolatedOpacityValue, startLoadingAnimation, startLoadingGradientAnimation } from '../SkeletonLoaderUtils';
import { GradientSkeleton } from './GradientSkeleton';
export var SkeletonLoaderComponent = forwardRef((props, ref) => {
  var stateContext = useContext(StateConfigContext);
  var skeletonLoaderProps = getSkeletonLoaderProps(props, stateContext);
  var breakpoint = useBreakpoint();
  var skeletonLoaderStyles = getSkeletonLoaderStyles(skeletonLoaderProps, breakpoint);
  var style = skeletonLoaderProps.style,
    animationDuration = skeletonLoaderProps.animationDuration,
    _skeletonLoaderProps$ = skeletonLoaderProps.testID,
    testID = _skeletonLoaderProps$ === void 0 ? 'SkeletonLoader' : _skeletonLoaderProps$,
    loaderType = skeletonLoaderProps.loaderType,
    _skeletonLoaderProps$2 = skeletonLoaderProps.gradientType,
    gradientType = _skeletonLoaderProps$2 === void 0 ? 'default' : _skeletonLoaderProps$2,
    restProps = __rest(skeletonLoaderProps, ["style", "animationDuration", "testID", "loaderType", "gradientType"]);
  var animated = useRef(new Animated.Value(0)).current;
  useEffect(() => {
    if (loaderType === 'gradient') startLoadingGradientAnimation(animated, animationDuration);else startLoadingAnimation(animated, animationDuration);
  }, [animationDuration]);
  var animatedStyle = {
    opacity: getInterpolatedOpacityValue(animated)
  };
  return _jsx(View, Object.assign({
    style: [skeletonLoaderStyles.container, style]
  }, getTestId(testID), {
    children: loaderType === 'gradient' ? _jsx(View, Object.assign({
      ref: ref,
      style: skeletonLoaderStyles.skeleton
    }, {
      children: _jsx(GradientSkeleton, {
        translateY: animated,
        gradientType: gradientType
      })
    })) : _jsx(Animated.View, Object.assign({
      ref: ref,
      style: [skeletonLoaderStyles.skeleton, animatedStyle]
    }, restProps))
  }));
});